module.exports = __webpack_public_path__ + "img/3.818f70a1.png";